// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable default-param-last */
import { createSelector } from "reselect"
import { Auth } from "@kiwicom/nitro/lib/records/Auth"
import { Context } from "@kiwicom/nitro/lib/services/auth/context"
import { User } from "@kiwicom/nitro/lib/records/User"

export type SetState = {
  type: "auth/SET_STATE"
  payload: Context
}

export type Action = SetState

const contextDefault: Context = {
  auth: null,
  loading: false,
  modal: null,
  state: "initial",
  onOpenModal: () => {},
  onCloseModal: () => {},
  onMyBooking: () => Promise.resolve(),
  onRegister: () => Promise.resolve(),
  onSocialAuth: () => Promise.resolve(),
  onSignIn: () => Promise.resolve(),
  onSignOut: () => {},
  onSetAuth: () => {},
  // @ts-expect-error: Flow to TS migration.
  onAppleAuth: () => Promise.resolve(),
  onFacebookAuth: () => Promise.resolve(),
  onGoogleAuth: () => Promise.resolve(),
}

function authReducer(state: Context | null | undefined = contextDefault, action: Action) {
  switch (action.type) {
    case "auth/SET_STATE":
      return action.payload

    default:
      return state
  }
}

export default authReducer

export const setState = (payload: Context): SetState => ({
  type: "auth/SET_STATE",
  payload,
})

export type State = {
  auth: Context
}

const getState = (state: State) => state.auth

export const getAuth = createSelector<State, undefined, Auth | null, Context>(
  // @ts-expect-error: Flow to TS migration.
  getState,
  // @ts-expect-error: Flow to TS migration.
  (state) => state.auth,
)

export const isLoading = createSelector<State, undefined, boolean, Context>(
  // @ts-expect-error: Flow to TS migration.
  getState,
  // @ts-expect-error: Flow to TS migration.
  (state) => state.loading,
)

// @ts-expect-error: Flow to TS migration.
export const getUser = createSelector<State, undefined, User | null, Auth | null>(getAuth, (auth) =>
  // @ts-expect-error: Flow to TS migration.
  auth?.type === "user" ? auth.user : null,
)
